export const TAB = {
  GROSS_RENT_CHANGES: 'GROSS_RENT_CHANGES',
  GROSS_RENT_CERTIFICATIONS: 'GROSS_RENT_CERTIFICATIONS',
};

export const DEFAULT_TAB = TAB.GROSS_RENT_CHANGES;
